import React from "react";

export default function SpacingBox() {
  return <div className="h-6" aria-hidden="true" />;
}
